<div class="references-grid">
  <div class="reference-category">
    <hyperkit-badge variant="neutral" text="General"></hyperkit-badge>
    @for (link of references?.general; track link) {
      <hyperkit-link
        [href]="link"
        target="_blank"
        variant="body"
        size="sm"
        color="secondary"
        [text]="link"
      ></hyperkit-link>
    } @empty {
      <hyperkit-typography display="block" variant="body" align="left" color="primary"
        >--</hyperkit-typography
      >
    }
  </div>
  <div class="reference-category">
    <hyperkit-badge variant="neutral" text="Analysis"></hyperkit-badge>
    @for (link of references?.analysis; track link) {
      <hyperkit-link
        [href]="link"
        target="_blank"
        variant="body"
        size="sm"
        color="secondary"
        [text]="link"
      ></hyperkit-link>
    } @empty {
      <hyperkit-typography display="block" variant="body" align="left" color="primary"
        >--</hyperkit-typography
      >
    }
  </div>
  <div class="reference-category">
    <hyperkit-badge variant="neutral" text="Blog Links"></hyperkit-badge>
    @for (link of references?.blog_links; track link) {
      <hyperkit-link
        [href]="link"
        target="_blank"
        variant="body"
        size="sm"
        color="secondary"
        [text]="link"
      ></hyperkit-link>
    } @empty {
      <hyperkit-typography display="block" variant="body" align="left" color="primary"
        >--</hyperkit-typography
      >
    }
  </div>
  <div class="reference-category">
    <hyperkit-badge variant="neutral" text="Malware Samples"></hyperkit-badge>
    @for (link of references?.malware_samples; track link) {
      <hyperkit-link
        [href]="link"
        target="_blank"
        variant="body"
        size="sm"
        color="secondary"
        [text]="link"
      ></hyperkit-link>
    } @empty {
      <hyperkit-typography display="block" variant="body" align="left" color="primary"
        >--</hyperkit-typography
      >
    }
  </div>
</div>
